import Configurator from 'layout/Configurator';
import Navigation from 'layout/Header';
import Home from 'layout/Home';

export default function Scene() {
  return (
    <div>
      <Navigation />
      <Home />
      <Configurator />
    </div>
  );
}
